import React, { useCallback, useState } from 'react';
import { Modal, Button, Tag, Spin, Form, Input } from 'antd';
import "./LabelModal.scss";
import "../../App.scss";
import { getIcon } from '../../../utils/images';
import { useFetch } from '../../../utils/hooks';
import { addShipmentLabel, getShipmentLabels, removeShipmentLabel } from '../../../services/shipments';

const LabelModalTitle = ({ handleCancel }) => {
  return (
    <div className='LabelModal__Title'>
      <img className='close' src={getIcon('close')} onClick={handleCancel} />
      <div className='title'>
        Add Labels
      </div>
    </div>
  )
};

const LabelItemElement = ({ label, removeLabel }) => {
  return (
    <div className='LabelModal__Element'>
      <Tag className='label' color="#DADCE0">{label}</Tag>
      <img className='close' src={getIcon('close')} onClick={() => removeLabel(label)} />
    </div>
  )
}

const LabelModal = ({ shipment, isOpen, handleCancel }) => {
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const { data, loading, refetch } = useFetch(useCallback(() => getShipmentLabels(shipment.id), [shipment.id]))
  const labels = data?.labels

  const handleFinish = async (values) => {
    await addShipmentLabel(shipment.id, values.label)
    form.resetFields();
    refetch();
    setIsDisabled(true); // Disable the button after adding a label
  }

  const removeLabel = async (label) => {
    await removeShipmentLabel(shipment.id, label)
    form.resetFields();
    refetch();
  }

  if (loading) return <></>

  return (
    <Modal
      className='App LabelModal'
      title={<LabelModalTitle handleCancel={handleCancel} />}
      open={isOpen}
      footer={null}
      closable={false}
      destroyOnClose={true}
      forceRender={true}
    >
      <div >
        <Form
          name="labels"
          onFinish={handleFinish}
          form={form}
          className='label-input'
          preserve={false}
        >
          <Form.Item name="label">
            <Input />
          </Form.Item>

          <Form.Item>
            <Button
              id="add"
              className='bold-btn'
              htmlType="submit"
              disabled={isDisabled}
            >
              Add
            </Button>
          </Form.Item>
        </Form>

      </div>
      {
        labels.length
          ? (
            <>
              <hr />
              <div className='label-items'>
                <div className='label-items__title'>
                  Labels
                </div>
                <div className='label-items__elements'>
                  {labels.map((label, index) => <LabelItemElement key={index} label={label} removeLabel={removeLabel} />)}
                </div>
              </div>
            </>
          )
          : <></>
      }
    </Modal>
  );
};

export default LabelModal;
